"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Reports";

export default {
  getReportMakingInfo(reportIdName) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/GetReportMakingInfo`,
        `?reportIDName=${reportIdName}&noOfInstances=1`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getReportData(reportRequest) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/GetReportData`, reportRequest).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
